import './styles/index.scss';
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import FirstComponent from './components/FirstComponent.vue';
import PageDetails from './components/Details.vue';
import OneContent from './components/Content1.vue';
import TwoContent from './components/Content2.vue';
Vue.component('PageDetails', PageDetails);
import SecondComponent from './components/SecondComponent.vue';
Vue.component('SecondComponent', SecondComponent);
Vue.component('FirstComponent', FirstComponent);
Vue.component('OneContent', OneContent);
Vue.component('TwoContent', TwoContent);
Vue.use(ElementUI);

Vue.config.productionTip = false;
import axios from 'axios';
import '../config/axios';
Vue.prototype.$ajax = axios;
Vue.prototype.baseConfig = baseConfig;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js